export const RQ_GET_DR_POTENTIAL_SUMMARY_API = {
  url:'doctorpotentialmaster/doctor-potential-summary-report/<%= locationId %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_DR_POTENTIAL_DETAIL_API = {
  url:'doctorpotentialmaster/doctor-potential-detail-report/<%= locationId %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_DR_POTENTIAL_INFO_API = {
  url:'doctorpotentialmaster/doctor-potential-info/<%= doctorUniqueCode %>',
  method:'GET',
  auth:true,
};

export const RQ_RESET_DR_POTENTIAL_DETAILS_API = {
  url: 'doctorpotentialmaster/reset-dr-potential/<%= doctorId %>',
  method: 'PUT',
  auth: true,
};
